import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate, useParams } from 'react-router-dom';
import { FunnelIcon, ChatBubbleLeftRightIcon, DocumentTextIcon, ChartBarIcon, UserGroupIcon } from '@heroicons/react/24/solid';
import Chats from './Chats';
import logo from '../logo.jpeg'; // Import the logo
import RAG from './RAG';
import Prompts from './Prompts';
import Stats from './Stats';
import Agents from './Agents'; // Import the new Agents component


const navigation = [
  { name: 'Chats', ref: 'chats', icon: ChatBubbleLeftRightIcon },
  { name: 'RAG', ref: 'rag', icon: FunnelIcon },
  { name: 'Prompts', ref: 'prompts', icon: DocumentTextIcon },
  { name: 'Statistics', ref: 'stats', icon: ChartBarIcon },
];
const agentNavigationItem = { name: 'Agents', ref: 'agents', icon: UserGroupIcon };

const Dashboard = () => {
  const { sectionName } = useParams();
  const navigate = useNavigate();
  const [activeNavItem, setActiveNavItem] = useState('chats');

  useEffect(() => {
    // Set the active nav item based on the URL parameter
    if (sectionName) {
      setActiveNavItem(sectionName);
    } else {
      setActiveNavItem('chats');
      navigate('/dashboard/chats'); // Default to chats
    }
  }, [sectionName, navigate]);

  const renderComponent = () => {
    switch (sectionName) {
      case 'chats':
        return <Chats />;
      case 'rag':
        return <RAG/>;
      case 'prompts':
        return <Prompts/>
      case 'stats':
        return <Stats/>
      case 'agents': // Add case for Agents
        return <Agents/>
      default:
        return <Chats />;
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  const handleNavigate = (section) => {
    navigate(`/dashboard/${section}`);
  };

  return (
    <div>
      <div className="sticky top-0 z-20 bg-white border-b border-gray-300 p-4 flex justify-between items-center">
        {/* Logo */}
        <img src={logo} alt="Logo" className="h-16 object-cover mr-20 ml-0" />

        {/* Navigation Menu */}
        <div className="flex space-x-4"> {/* Existing navigation items */}
          {navigation.map((item) => (
            <button
              key={item.name}
              onClick={() => handleNavigate(item.ref)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition duration-300 ${
                activeNavItem === item.ref
                  ? 'text-white bg-[#4790CF]'
                  : 'text-gray-700 hover:text-[#4790CF]'
              }`}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.name}</span>
            </button>
          ))}
          {/* Add Agents navigation item separately to ensure it's always there */}
          <button
            key={agentNavigationItem.name}
            onClick={() => handleNavigate(agentNavigationItem.ref)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition duration-300 ${
              activeNavItem === agentNavigationItem.ref
                ? 'text-white bg-[#4790CF]'
                : 'text-gray-700 hover:text-[#4790CF]'
            }`}
          >
            <agentNavigationItem.icon className="h-5 w-5" />
            <span>{agentNavigationItem.name}</span>
            </button>
        </div>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="ml-auto text-red-500 font-medium hover:text-red-600 transition duration-300"
        >
          Logout
        </button>
      </div>
      <div id="snackbar-root" className='m-50'></div>
      {renderComponent()}
    </div>
  );
};

export default Dashboard;
